import { DataModelType, ThreeCharacterMonths } from "../../config/enums";
import {
  isDecimalNumber,
  isMonthDayValue,
  isWholeNumber,
} from "../../utils/valueFormats";
import { FieldValidator } from "../../config/fieldValidators";
import { PicklistOption } from "../../blocks/fields/PicklistField.types";

/** The type picklist's choices, from the enum the legacy page used. */
export const dataModelTypeOptions: PicklistOption[] = Object.entries(
  DataModelType
).map(([label, value]) => ({ Key: value, Value: label }));

/** A value must read as its type: a whole number, a decimal, or a MMM-DD day. */
const dataModelValue: FieldValidator = (value, record) => {
  const trimmed = String(value ?? "").trim().toUpperCase();

  // Blank is the browser's "required" to report, not this rule's.
  if (trimmed === "") {
    return "";
  }

  switch (Number(record.type)) {
    case DataModelType.Number:
      return isWholeNumber(trimmed) ? "" : "Enter a whole number";
    case DataModelType.Decimal:
      return isDecimalNumber(trimmed) ? "" : "Enter a decimal number";
    case DataModelType.Date:
      return isMonthDayValue(trimmed, Object.values(ThreeCharacterMonths))
        ? ""
        : "Enter a date in MMM-DD format, for example JAN-01";
    default:
      return "";
  }
};

export const dataModelValidators = { dataModelValue };
